import { render, staticRenderFns } from "./BillingTopUpModal.vue?vue&type=template&id=bff79dda&"
import script from "./BillingTopUpModal.vue?vue&type=script&lang=js&"
export * from "./BillingTopUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports